import React, {useMemo} from 'react';
import {Stack, Typography, Button, Box} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useOutletContext } from 'react-router-dom';
import { When } from "react-if";
import ReportsBackIcon from "../../../../assets/icons/reports-back-icon";
import {About} from "./about";
import {TeamSelect} from "./team-select";
import {useGenericQuery} from "../../../../services/react-query/generic.query";
import {Team} from "../../../../types/teams.types";
import {DateSelect} from "./date-select";
import {RiskReviewsList} from "../../../../components/lists/risk-reviews-list";
import {Dayjs} from "dayjs";

export const RiskReview: React.FC = () => {

    interface ContextType {
        setReportTitle: (title: string) => void;
        setReportDescText: (desc: string) => void;
    }

    const SCREENS = {
        ABOUT: 0,
        TEAM_SELECT: 1,
        DATE_SELECT: 2,
        RESULT: 3
    }
    const { setReportTitle, setReportDescText } = useOutletContext<ContextType>();
    useMemo(() => {
        setReportTitle("Visit Risk Review");
        setReportDescText("Run a report to review all flagged visits at addresses where your team has identified a need for a risk assessment.");
    }, []);

    const navigate = useNavigate();
    const [selectedTeams, setSelectedTeams] = React.useState<Team[]>([]);
    const [screenCount, setScreenCount] = React.useState<number>(SCREENS.ABOUT);
    const [startDate, setStartDate] = React.useState<Dayjs | null>(null);
    const [endDate, setEndDate] = React.useState<Dayjs | null>(null);

    const { data: allTeams, isLoading : isTeamsLoading } = useGenericQuery<Team[]>(
        'fetchTeams',
        'teams/fetchTeams',
        0,
        0,
        false
    );

    const handleBack = () => {
        if(screenCount === SCREENS.ABOUT){
            navigate("/reports/")
        }else{
            setScreenCount(screenCount-1);
        }
    }

    const handleNext = () => {
        setScreenCount(screenCount+1);
    }

    return (
        <Stack>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                flexWrap: 'wrap',
                justifyContent: 'left',
                textAlign: 'left',
                marginTop: 4,
                marginBottom: 6
            }}>
                <Button
                    variant="outlined"
                    color="inherit"
                    onClick={handleBack}
                    disabled={false}
                    sx={{
                        border : 0,
                        padding:1,
                        boxShadow : '0 0 2px 0 rgba(145, 158, 171, 0.24),0 16px 32px -4px rgba(145, 158, 171, 0.24)'
                    }}
                >
                    <ReportsBackIcon/>
                    <Typography fontWeight={400} fontSize={14} color={'black'} marginLeft={1}>
                        Back
                    </Typography>
                </Button>
            </Box>
            <When condition={screenCount === SCREENS.ABOUT}>
                <About isTeamsLoading={isTeamsLoading!} handleNext={handleNext} handleBack={handleBack}/>
            </When>
            <When condition={screenCount === SCREENS.TEAM_SELECT}>
                <TeamSelect allTeams={allTeams!}
                            selectedTeams={selectedTeams}
                            setSelectedTeams={setSelectedTeams}
                            isTeamsLoading={isTeamsLoading!}
                            handleNext={handleNext}
                />
            </When>
            <When condition={screenCount === SCREENS.DATE_SELECT}>
                <DateSelect setStartDate={setStartDate}
                            setEndDate={setEndDate}
                            startDate={startDate}
                            endDate={endDate}
                            handleBack={handleBack} handleNext={handleNext}/>
            </When>
            <When condition={screenCount === SCREENS.RESULT}>
                <RiskReviewsList
                    fromDate={startDate?.toISOString()!}
                    toDate={endDate?.toISOString()!}
                    selectedTeams={selectedTeams}
                />
            </When>
        </Stack>

    )
}
